import { Menu } from '@szhsin/react-menu';
import { useTranslation } from 'react-i18next';
import NotificationItem from './NotificationItem';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import NotificationsHeader from './NotificationsHeader';
import voidImg from '../Images/void.svg';
import './Notifications.css';

function ONotificationsList({
  children,
  align,
  options,
  onRead,
  onOpenDetails,
  onReadAll,
  unreadOnly = false,
  onUnreadFilterChange,
  onOpen,
}) {
  const { t } = useTranslation();

  const handleOpenMessage = (item) => {
    // Samo označi kao pročitano, bez otvaranja taba
    if (!item.read && onRead) {
      onRead(item, { openMessageOnly: true });
    }
  };

  const handleSelect = (item) => {
    if (item.hasDetails && onOpenDetails) {
      onOpenDetails(item);
      return;
    }
    handleOpenMessage(item);
  };

  return (
    <Menu
      align={align}
      menuButton={children}
      transition
      menuClassName="not-dropdown-menu"
      portal
      onMenuChange={(e) => {
        if (e.open) onOpen?.();
      }}
    >
      <div className="not-list-wrapper">
        <NotificationsHeader
          onReadAll={onReadAll}
          unreadOnly={unreadOnly}
          onUnreadFilterChange={onUnreadFilterChange}
        />
        {options.length > 0 ? (
          options.map((item) => (
            <div key={item.id} className="not-list-item-wrap">
              <NotificationItem
                option={item}
                onSelect={() => handleSelect(item)}
                onOpenMessage={() => handleOpenMessage(item)}
              />
            </div>
          ))
        ) : (
          <div className="not-no-data-wrapper">
            <img src={voidImg} alt="No data img" width="120px" />
            <span className="not-no-data-span">
              {unreadOnly
                ? t('notifications.noUnread')
                : t('notifications.empty')}
            </span>
          </div>
        )}
      </div>
    </Menu>
  );
}

export default ONotificationsList;
